<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/atoms/Spinner'

export default {
    name: 'HeaderCart',
    components: { Spinner },
    computed: {
        ...mapGetters({
            smDevice: 'smDevice',
            orderRestaurant: 'order/restaurant',
            activeRestaurant: 'active/restaurant',
            restaurantView: 'site/restaurantView',
        }),
        cart() {
            return this.$cart
        },
        value() {
            return (this.cart?.items?.length ? this.cart.calculation?.price_sum : 0) || 0
        },
        authPage() {
            return this.$route.meta.auth
        },
        isCartPage() {
            return this.orderRestaurant.id === this.activeRestaurant.id && this.restaurantView
        },
        isCheckoutPage() {
            return this.$route.name === 'checkout'
        },
        isLoggedIn() {
            return this.$user.isLoggedIn
        },
        disabled() {
            return !this.value || this.isCartPage || this.isCheckoutPage
        },
        currency() {
            return this.orderRestaurant?.country || {}
        },
        loading() {
            return this.cart?.loading
        },
        hideCart() {
            return this.smDevice || this.isCartPage || !this.value
        },
    },
    methods: {
        viewCart() {
            if (!this.isCartPage) {
                this.$router.push({
                    name: 'restaurant',
                    params: {
                        slug: this.orderRestaurant.slug,
                    },
                })
            }
        },
    },
}
</script>

<template lang="pug">
transition(name="fade")
    button.btn(
        v-if="!authPage && !hideCart"
        :class="[disabled ? 'btn-secondary' : 'btn-primary', {'btn-xs': smDevice}]"
        :disabled="disabled"
        @click="viewCart")
        icon.mr-4(icon="fa-solid fa-shopping-cart")
        //spinner(v-if="loading" :size="20" :class="disabled ? 'spinner-secondary' : 'spinner-primary'")
        | {{ value | toCurrency(currency.locale, currency.currency_code) }}
</template>
